import { render, staticRenderFns } from "./manage-diodes.vue?vue&type=template&id=c58883f8&scoped=true&"
import script from "./manage-diodes.vue?vue&type=script&lang=js&"
export * from "./manage-diodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58883f8",
  null
  
)

export default component.exports